import React from 'react'
import { Divider, Dropdown, Option, tokens } from '@fluentui/react-components'
import { Control, Controller } from 'react-hook-form'
import { t } from '../../../i18n/i18n'
import { CheckboxCheckedFilled } from '@fluentui/react-icons'
import { Text } from '@fluentui/react-components'
import { Field } from './Field'
import { ConditionalTooltip } from '../other/ConditionalTooltip'
type ControlledSimpleDropdownProps = {
   options: string[]
   name: any
   control: Control<any>
   label: string
   showTooltip?: boolean
   tooltipMsg?: string
   required?: boolean
   disabled?: boolean
}
export const ControlledSimpleDropdown = ({
   options,
   name,
   control,
   label,
   showTooltip,
   tooltipMsg,
   required,
   disabled,
}: ControlledSimpleDropdownProps): JSX.Element => {
   const handleSelectAll = (currentValues: string[], onChange: Function) => {
      const actualSelected = currentValues.filter((v) => v !== 'all')

      if (actualSelected.length < options.length) {
         onChange(options)
      } else {
         onChange([])
      }
   }
   return (
      <Controller
         name={name}
         control={control}
         rules={{ required: required ? t('RequiredField') : false }}
         render={({ field: { onChange, value }, fieldState: { error } }) => {
            const safeValue = value ?? []

            return (
               <Field label={label} required={required ?? false} validationMessage={error ? error.message : null} validationState={error ? 'error' : null}>
                  <ConditionalTooltip show={showTooltip} content={tooltipMsg}>
                     <Dropdown
                        onOptionSelect={(e, d) => {
                           if (d.optionValue === 'all') {
                              handleSelectAll(safeValue, onChange)
                           } else {
                              onChange(d.selectedOptions.filter((v) => v !== 'all'))
                           }
                        }}
                        value={safeValue && safeValue.length > 0 && safeValue.length === options.length ? t('All') : safeValue?.join(', ')}
                        multiselect
                        selectedOptions={safeValue}
                        disabled={disabled || options.length === 0}
                     >
                        {options.length > 0 && (
                           <>
                              <Option text={t('All')} checkIcon={safeValue.length >= options.length && null} value="all">
                                 <span style={{ position: 'relative', left: '-5px', display: 'flex' }}>
                                    {safeValue.length === options.length && (
                                       <CheckboxCheckedFilled style={{ fontSize: '23px' }} color={tokens.colorBrandForeground1} />
                                    )}
                                    <Text style={{ marginLeft: safeValue.length === options.length ? '2px' : '5px' }}> {t('All')}</Text>
                                 </span>
                              </Option>
                              <Divider/>
                              {options.map((x) => (
                                 <Option key={x}>{x}</Option>
                              ))}
                           </>
                        )}
                     </Dropdown>
                  </ConditionalTooltip>
               </Field>
            )
         }}
      />
   )
}
